<template>
  <FormLabel :checkboxmode="true" :descr="descr" @click.native.prevent="delayBlur" :disabled="disabled" >
    <HiddenField type='checkbox' :name="name" :checked="val" :disabled="disabled"/>
    <div @click.stop role="checkbox" :aria-checked="val" :tabindex="disabled? false:0" class="formcheckbox" :class="{'formcheckbox_disabled':disabled}" @click="val = !val" @keydown.enter.space.stop="val = !val">
      <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 8L6 12L14 2" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
  </FormLabel> 
</template>

<script>
import FormLabel from '@/components/FormLabel.vue'
import FormField from '@/mixins/FormField.vue'
import HiddenField from '@/components/HiddenField.vue'

export default {
  components: { FormLabel, HiddenField },
  mixins: [FormField],
  props: {
    name: {type: String, required: true},
    descr: {type: String, required: true},
    value: {type: Boolean, default: false},
    disabled: {type: Boolean, default: false}
  },
  methods:{
    delayBlur(){
      setTimeout(()=>document.activeElement.blur(), 50)
    }
  },
  computed:{
    val: {
      get () { return this.value },
      set (value) { this.$emit('input', value) },
    },
  },
  watch:{
    value(val, old){
      if (val != old)
        this.$emit('input', val)
    }
  }
}
</script>

<style lang="sass">
.formcheckbox
  &, *
    outline: none
  position: relative
  z-index: 1
  &::before
    content: ''
    position: absolute
    top: -15px
    left: -15px
    right: -15px
    bottom: -15px
  display: flex
  justify-content: center
  align-items: center
  width: 24px
  min-width: 24px
  height: 24px
  border: 2px solid colors.$light
  cursor: pointer
  transition: border-color .2s ease-out
  &_disabled
    cursor: auto
    pointer-events: none
  svg
    transition: opacity .2s ease-out
    stroke: colors.$red
    opacity: 0
  &:hover, &:focus-within
    border-color: colors.$gray
  &[aria-checked=true]
    border-color: colors.$gray
    svg
      opacity: 1

</style>